import Vue from "vue";

var monkey = "";
var templateId = "";

export default {
  monkey,
  templateId
};



// WEBPACK FOOTER //
// ./src/utils/common.js